import { DadosExportar } from './dados-exportar';
import { ExportacaoDadosAluno } from './exportacao-dados-aluno';

export class ListaCompletaDadosExportar {

	listaDadosExportacao: ExportacaoDadosAluno[];
	exportarDados: DadosExportar;
}